import {ProductFormAction, ProductFormState} from './productFormActions';

const {
    OPEN_PRODUCT_INSPECTOR_ONLY,
    OPEN_INSPECTOR_AND_FORM,
    OPEN_PRODUCT_FORM_ONLY,
    SET_PRODUCT_TO_INSPECT,
    CLOSE_PRODUCT_FORM_ONLY,
    CLOSE_ALL,
} = ProductFormAction;

export interface TypeOfProductFormAction {
    type: ProductFormAction;
    productFormState: Partial<ProductFormState>;
}

export const ProductFormReducer = (
    previousState: ProductFormState,
    action: TypeOfProductFormAction
): ProductFormState => {
    const {type, productFormState: newProductFormState} = action;

    switch (type) {
        case OPEN_PRODUCT_INSPECTOR_ONLY:
        case OPEN_INSPECTOR_AND_FORM:
        case OPEN_PRODUCT_FORM_ONLY:
        case SET_PRODUCT_TO_INSPECT:
        case CLOSE_PRODUCT_FORM_ONLY:
        case CLOSE_ALL:
            return {
                ...previousState,
                ...newProductFormState,
            };
        default:
            return previousState;
    }
};
